import { Component, input } from "@angular/core";
import { ModuleManager } from "src/shared/models/module-manager";

@Component({
    selector: "cv-expanded-summary-cxone",
    templateUrl: "./expanded-summary-cxone.component.html",
    styleUrl: "./expanded-summary-cxone.component.scss",
})
export class ExpandedSummaryCxoneComponent {
    moduleKey = input.required<string>();
    moduleManager = input.required<ModuleManager>();
}
